import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import { useCallback } from "react";

type AgendaTrpcClient = ReturnType<typeof trpc.useTRPC>;

const agendaQueryKeys = (trpcClient: AgendaTrpcClient) => [
    trpcClient.marketingPlaybook.dueTouchpoints.queryKey(),
    trpcClient.marketingPlaybook.activeSnoozes.queryKey(),
    trpcClient.calendarEvents.listForCalendar.queryKey(),
    trpcClient.marketingPlaybook.contactPlan.queryKey(),
    trpcClient.touchpoint.myActivity.queryKey(),
];

const invalidateAgendaQueries = async (
    trpcClient: AgendaTrpcClient,
    queryClient: QueryClient,
): Promise<void> => {
    await Promise.all(
        agendaQueryKeys(trpcClient).map(queryKey =>
            queryClient.invalidateQueries({ queryKey }),
        ),
    );
};

export const useAgendaRefresh = () => {
    const trpcClient = trpc.useTRPC();
    const queryClient = useQueryClient();
    return useCallback(
        () => invalidateAgendaQueries(trpcClient, queryClient),
        [trpcClient, queryClient],
    );
};
